import { useContext } from "react";
import { ProgramContext, ProgramContextType } from "./context";

export function useProgram() {
  const context = useContext(ProgramContext);
  if (context === undefined) {
    throw new Error("useProgram must be used within a ProgramProvider");
  }
  return context as ProgramContextType;
} 